import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { map } from 'rxjs/operators';
import { Cacheable } from 'ngx-cacheable';
import { FormType } from '../api/src/app/models/REGBP-V1.0.0/form-type.model';

@Injectable({
  providedIn: 'root'
})
export class FormTypeFacade {
  constructor(public regbpService: RegbpService) {}

  @Cacheable({ maxCacheCount: 6 })
  getFormtypes(infile: boolean, language: string): Observable<FormType[]> {
    return this.regbpService.getFormTypeList(infile, language).pipe(
      map((results: any) => results.$response.body.values)
    );
  }
}
